import type { SortDirection } from '@angular/material/sort';

export const OrderByDirections = ['asc', 'desc'] as const;
export type OrderByDirection = (typeof OrderByDirections)[number];

export function matOrderToOrderByDirection(matOrder: SortDirection): OrderByDirection | undefined {
  if (matOrder === '') {
    return undefined;
  }
  return matOrder === 'desc' ? 'desc' : 'asc';
}

export function orderByDirectionToMatOrder(order: OrderByDirection): SortDirection {
  return order === 'desc' ? 'desc' : 'asc';
}
